export enum MappingTableLabelEnum {
  SystemFieldName = 'System field name',
  RequiredField = '',
  FileFieldName = 'File field name',
}
